import { render } from "./SkelInput.vue?vue&type=template&id=05d215eb&scoped=true"
import script from "./SkelInput.vue?vue&type=script&lang=js"
export * from "./SkelInput.vue?vue&type=script&lang=js"

import "./SkelInput.vue?vue&type=style&index=0&id=05d215eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d215eb"]])

export default __exports__